import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function DownloadIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 20h14q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 19 22H5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 21q0-.424.287-.712A.97.97 0 0 1 5 20m7-2.625q-.225 0-.437-.1a.96.96 0 0 1-.363-.3l-4.95-6.35q-.375-.5-.1-1.062Q6.424 9 7.05 9H9V3q0-.424.287-.712A.97.97 0 0 1 10 2h4q.424 0 .713.288Q15 2.575 15 3v6h1.95q.625 0 .9.563t-.1 1.062l-4.95 6.35a.96.96 0 0 1-.363.3q-.212.1-.437.1"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
